import React from 'react'
import styled from 'styled-components'
import { Responsive, Size } from 'const'
import { ReactComponent as GlassesIcon } from 'assets/svg/glasses.svg'
import ClViewer from '../ClViewer'
import { isBeforeOrEqualMock } from 'utils/helpers/function'

const Frame = ({ content, isSameSalesDate = true }) => {
  if (!content?.brand || !content?.name) return null

  const isBeforeOrEqual31thMarch2025 = isBeforeOrEqualMock(content.dev_sales_date, '2025-03-31')

  return (
    <StyledFrame>
      <div className="item_header">
        <GlassesIcon />
        <div className="item_type">フレーム</div>
        <div className="item_name">
          {content?.brand} {content?.name}
        </div>
      </div>
      <div className="row">
        <div className="label">フレームカラー</div>
        <div className="content">{content?.color || 'ー'}</div>
      </div>
      <div className="row">
        <div className="label">サイズ</div>
        <div className="content">
          レンズ幅：{content?.lenz_width ? content?.lenz_width + 'mm' : 'ー'}／ブリッジ：
          {content?.bridge ? content?.bridge + 'mm' : 'ー'}／テンプル：{content?.temple ? content?.temple + 'mm' : 'ー'}
        </div>
      </div>
      <div className="row">
        <div className="label">素材</div>
        <div className="content">{content?.material ? content?.material.replace(/^[0-9]{3}:/g, '') : 'ー'}</div>
      </div>
      <div className="row">
        <div className="label">構造</div>
        <div className="content">{content?.design ? content?.design.replace(/^[0-9]{3}:/g, '') : 'ー'}</div>
      </div>
      {!isSameSalesDate && (
        <div className="row">
          <ClViewer isContactLens={false} isBeforeOrEqual31thMarch2025={isBeforeOrEqual31thMarch2025} />
        </div>
      )}
    </StyledFrame>
  )
}

const StyledFrame = styled.div`
  > .item_header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 30px 0;

    > .item_type {
      font-size: ${Size.FONT.LG};
      margin: 4px 0;
      font-weight: 500;
    }
    > .item_name {
      font-size: ${Size.FONT.ITEM_NAME};
      font-weight: 500;

      @media screen and (max-width: ${Responsive.XS.DOWN}px) {
        font-size: ${Size.FONT.LG};
      }
    }
  }
  > .row {
    display: flex;
    margin-bottom: 15px;
    > .label {
      width: 91px;
      margin-right: 24px;
      font-weight: 700;
      font-size: ${Size.FONT.BIG};
      @media screen and (max-width: ${Responsive.XS.DOWN}px) {
        width: 100%;
      }
    }
    > .content {
      font-size: ${Size.FONT.BIGGER};
      font-weight: 500;
      width: 100%;
    }

    @media screen and (max-width: ${Responsive.XS.DOWN}px) {
      flex-wrap: wrap;
    }
  }
`

export default Frame
